export default "__VITE_ASSET__BqntbQ3___"